<template>
    <div class="input-daterange form-group row">
        <div class="input-date-time-picker" >
            <div class="col-xs-12">
                
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="col-md-6">
                        <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                        <date-picker
                            class="el-input__inner form-control"
                            v-model="startDate"
                            type="date"
                            placeholder=""
                            clear-icon=""
                            format="yyyy-MM-dd"
                            value-format="timestamp"
                        />
                    </div>
                    <div class="col-md-6">
                        <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                        <time-select
                            v-model="startTime"
                            placeholder=""
                            clear-icon=""
                            :picker-options="{
                                start: '00:00',
                                step: '01:00',
                                end: '24:00'
                            }"
                        />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="col-md-6">
                        <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                        <date-picker
                            class="el-input__inner form-control"
                            v-model="endDate"
                            type="date"
                            placeholder=""
                            clear-icon=""
                            format="yyyy-MM-dd"
                            value-format="timestamp"
                        />
                    </div>
                    <div class="col-md-6">
                        <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                        <time-select
                            v-model="endTime"
                            placeholder=""
                            clear-icon=""
                            :picker-options="{
                                start: '00:00',
                                step: '01:00',
                                end: '24:00'
                            }"
                        />
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="form-group">
                        <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>
                        <div class="col-xs-9">
                            <select class="form-control" v-model=dataSamplingSelect size="1">
                                <option value="Automatic">{{labelDataSamplingAuto[actualLanguage]}}</option>
                                <option value="5Min">{{labelDataSampling5min[actualLanguage]}}</option>
                                <option value="Hour">{{labelDataSamplingHour[actualLanguage]}}</option>
                                <option value="Day">{{labelDataSamplingDays[actualLanguage]}}</option>
                            </select>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-xs-12">
                <div class="col-md-3 col-xs-12 text-center">
                    <button type="button" @click="refresh" class="btn btn-block btn-success" name="button"><span><i class="fa fa-repeat"></i> {{ labelButtonObserve[actualLanguage] }}</span></button>
                </div>
                <div class="col-md-9 col-xs-12">
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(14400,true)" class="btn btn-block btn-success" name="button">{{ labelButton4Hour[actualLanguage] }}</button>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(43200,true)" class="btn btn-block btn-success" name="button">{{ labelButton12Hour[actualLanguage] }}</button>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(1,true)" class="btn btn-block btn-success" name="button">{{ labelButtonToday[actualLanguage] }}</button>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(4,true)" class="btn btn-block btn-success" name="button">{{ labelButton3Days[actualLanguage] }}</button>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(8,true)" class="btn btn-block btn-success" name="button">{{ labelButton7Days[actualLanguage] }}</button>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6">
                        <button type="button" @click="setPresets(29,true)" class="btn btn-block btn-success" name="button">{{ labelButton4Weeks[actualLanguage] }}</button>
                    </div>
                </div>
            </div>

        </div>


<!--
        <div class="form-group">
            <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>
            <div class="col-xs-12">
                <label class="radio-inline" for="example-inline-radio1">
                    <input type="radio" value="Automatic" v-model="dataSamplingSelect"> {{labelDataSamplingAuto[actualLanguage]}}
                </label>
                <label class="radio-inline" for="example-inline-radio2">
                    <input type="radio" value="5Min" v-model="dataSamplingSelect"> {{labelDataSampling5min[actualLanguage]}}
                </label>
                <label class="radio-inline" for="example-inline-radio3">
                    <input type="radio" value="Hour" v-model="dataSamplingSelect"> {{labelDataSamplingHour[actualLanguage]}}
                </label>
                <label class="radio-inline" for="example-inline-radio3">
                    <input type="radio" value="Day" v-model="dataSamplingSelect"> {{labelDataSamplingDays[actualLanguage]}}
                </label>
            </div>
        </div>
-->




    </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  name: 'rangePicker',

  components: {
    DatePicker,
    TimePicker,
    TimeSelect,
  },

  data() {
    return {
        startDate: new Date(this.$store.state.chargesStore.startDate * 1000),
        endDate: new Date(this.$store.state.chargesStore.endDate * 1000),
        startTime: '00:00',
        endTime: '00:00',
        actualLanguage : "FR",
        labelStartDate: {FR: 'Date de début', EN: 'Start date'},
        labelStartTime: {FR: 'Heure de début', EN: 'Start time'},
        dataSamplingSelect : 'Automatic',

        labelEndDate: {FR: 'Date de fin', EN: 'End date'},
        labelEndTime: {FR: 'Heure de fin', EN: 'End time'},
        labelButtonObserve: {FR: 'Rafraichir', EN: 'Refresh'},
        labelButton4Hour: {FR: '4 Hrs', EN: '4 Hrs'},
        labelButton12Hour: {FR: '12 Hrs', EN: '12 Hrs'},
        labelButtonToday: {FR: "Aujourd'hui", EN: 'Today'},
        labelButton3Days: {FR: '3 Jours', EN: '3 Days'},
        labelButton7Days: {FR: '7 jours', EN: '7 Days'},
        labelButton4Weeks: {FR: '4 semaines', EN: '4 weeks'},
        labelDataSamplingTitle: {FR: 'Type de données des graphiques :', EN: 'Graph data type :'},
        labelDataSamplingAuto: {FR: 'Automatique', EN: 'Automatic'},
        labelDataSampling5min: {FR: '5 minutes', EN: '5 minute'},
        labelDataSamplingHour: {FR: 'Heure', EN: 'Hour'},
        labelDataSamplingDays: {FR: 'Jour', EN: 'Days'},
        
    }
  },

    computed: {
    ...mapState('sessionStore', ['actualBundle']),
  },

  methods: {

    refresh() {
        const startDate = this.formatTimeToUnix(this.startDate, this.startTime)
        const endDate = this.formatTimeToUnix(this.endDate, this.endTime)
        //console.log("----RANGE PICKER : start end Date-----")
        //console.log(startDate)
        //console.log(endDate)

        this.$emit('refresh', {startDate, endDate})
        //this.$store.dispatch('chargesStore/summarize')

        //console.log(this.actualBundle)
        var channelListToRead = []
        for (let j = 0; j < this.actualBundle.channels.length;j++){
            if(this.actualBundle.channels[j].ChannelData.DisplayOpenFlag){
                channelListToRead.push({'channelData': this.actualBundle.channels[j].ChannelData,
                                        'channelBundleIndex':j})
            }
        }
        this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', false)

        var requestData = { 'postAction':'GetBundleChannelReadings',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelList':channelListToRead,
                            'start':startDate,
                            'end':endDate,
                            'dataType':this.dataSamplingSelect,
                            } 


        this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                //console.log('---Range Picker : Bundle Channel readings updated---')
                this.$store.dispatch('sessionStore/setDisplayAllChannelGraphFlag', true)
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            })
            
    
    },


    setPresets(rangeType,callRefresh) {
        //moment().unix()
        this.rangeType = rangeType <= 60 ? (rangeType * 86400) : rangeType;
        this.endDate = (moment().unix() * 1000);
        this.startDate = moment(this.endDate).subtract(this.rangeType, 'seconds');

        
        if(rangeType > 30) {
            const startTime = moment()
            
            this.endTime = moment(this.endDate).format('HH:mm');
            this.startTime = moment(this.startDate).format('HH:mm');
        } else {
            this.startTime = '24:00'
            this.endTime = '24:00'
        }



        if(callRefresh){
            this.refresh()
            //console.log('--RangePicker:Refresh called--')
            }
        //this.refresh();
    },

    formatTimeToUnix(date, time) {
        const unixTime = moment(date)
        .set('hour', time.split(':')[0])
        .set('minute', time.split(':')[1])
        .set('seconds', 0)
        .unix()

        return unixTime
    },
  },

  mounted() {
    //console.log('----RANGE PICKER MOUNT-----')
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.setPresets(28800,true)
    //this.refresh()
 }

 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-date-editor input {
    text-align: left;
    border-radius: 0;
    border: 0;
    min-width: 100%;
}

.presets-container {
    margin: 40px 0 20px;
}

.presets-container .btn {
    margin: 5px;
}

.el-input__inner {
    border: 0;
}
.el-input--suffix .el-input__inner {
    padding-right: 0;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.time-select-item.selected:not(.disabled),
.el-date-table td.today span {
    color: #46c37b;
}

.el-date-table td.current:not(.disabled) span {
    color: #fff;
    background-color: #46c37b;
}

.time-select-item {
    text-align: center;
}


</style>



// WEBPACK FOOTER //
// RangePicker.vue?039ab384